import { render, staticRenderFns } from "./SingleBook.vue?vue&type=template&id=9a11623a&scoped=true"
import script from "./SingleBook.vue?vue&type=script&lang=js"
export * from "./SingleBook.vue?vue&type=script&lang=js"
import style0 from "./SingleBook.vue?vue&type=style&index=0&id=9a11623a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a11623a",
  null
  
)

export default component.exports